import { limitStrategy } from './limitStrategy';
import { Limit } from './Limit';
export var limit = function limit(limitChars) {
  return {
    strategy: limitStrategy(limitChars),
    component: Limit
  };
};